import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { routerPath } from '../../router/routerPath';
import {
  BlueLayout,
  CustomButton,
  CustomGoBackButton,
  FormBlock,
  FormContainer,
  FormInput,
  PagesContainerUI,
} from '../../styles/styled';
import { DocumentCategoriesType } from '../DocumentCategoryPage/types';
import { DocumentCategoryRequestType } from './types';

export const NewDocumentCategory = () => {
  const [documentCategoryState, setDocumentCategory] = useState<DocumentCategoryRequestType>({ sort: 0 });
  const [requestState, setRequest] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get<DocumentCategoriesType>(endpoints.getDocumentCategories());

        setDocumentCategory({ ...documentCategoryState, sort: response.data.length + 1 });
      } catch (err) {}
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (requestState) {
      (async () => {
        try {
          const response = await api.post(endpoints.postDocumentCategory(), documentCategoryState);

          setRequest(false);

          if (response) {
            navigate(routerPath.document_category, { replace: true });
          }
        } catch {}
      })();
    }
    // eslint-disable-next-line
  }, [requestState]);

  return (
    <PagesContainerUI>
      <BlueLayout>
        <Link to={routerPath.document_category}>
          <CustomGoBackButton>{'<'}</CustomGoBackButton>
        </Link>
        Добавить раздел
      </BlueLayout>

      <FormBlock white>
        <FormContainer>
          <Form onFinish={() => setRequest(true)}>
            <Row gutter={[20, 20]}>
              <Col span={24}>
                <div className="text red-star">Наименование</div>

                <Form.Item
                  label="Наименование"
                  name="name"
                  rules={[{ required: true, message: 'Пожалуйста, введите наименование документа' }]}
                >
                  <FormInput
                    value={documentCategoryState.title}
                    onChange={(e) => setDocumentCategory({ ...documentCategoryState, title: e.target.value })}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div className="text">Содержание</div>
                <Form.Item label="Содержание" name="content" rules={[{ required: false }]}>
                  <FormInput
                    value={documentCategoryState.description}
                    onChange={(e) => setDocumentCategory({ ...documentCategoryState, description: e.target.value })}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div className="gray-block">
                  <div className="text">не создано ни одного подраздела</div>
                </div>
              </Col>
            </Row>
            <br />
            <div className="center">
              <CustomButton>Сохранить</CustomButton>
            </div>
          </Form>
        </FormContainer>
      </FormBlock>
    </PagesContainerUI>
  );
};
